import React, { createContext, useContext, useState, useEffect } from 'react';

const PRESETS = {
  lime:   '#C8FF00',
  cyan:   '#00E5FF',
  purple: '#A855F7',
  orange: '#FF6B2B',
  pink:   '#FF2D78',
  blue:   '#3B82F6',
};

const DEFAULT = PRESETS.lime;

const ThemeContext = createContext({ accent: DEFAULT, setAccent: () => {} });

export function ThemeProvider({ children }) {
  const [accent, setAccentState] = useState(() => {
    return localStorage.getItem('dash-accent') || DEFAULT;
  });

  const setAccent = (hex) => {
    localStorage.setItem('dash-accent', hex);
    setAccentState(hex);
  };

  return (
    <ThemeContext.Provider value={{ accent, setAccent, PRESETS }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
